export const SCROLL_BAR_STYLE_PROPS = {
    '::-webkit-scrollbar': {
        width: '7px',
    },
    '::-webkit-scrollbar-track': {
        background: '#E1E1E1E0',
        borderRadius: '10px',
    },
    '::-webkit-scrollbar-thumb': {
        background: '#3ED4DC',
        borderRadius: '10px',
        transition: 'background 200ms ease-in-out'
    },
    '::-webkit-scrollbar-thumb:hover': {
        background: '#2d979d'
    }
}